// ═══════════════════════════════════════════════════════════════════════════════
// ui--manifesto--counter-up-v3
// ───────────────────────────────────────────────────────────────────────────────
// Wraps countup.js — анимированные счётчики с auto-trigger через IntersectionObserver.
// Параметры через data-attributes:
//   data-ui--manifesto--counter-up-v3-target-value    = number (обязательно)
//   data-ui--manifesto--counter-up-v3-duration-value  = seconds (default 2)
//   data-ui--manifesto--counter-up-v3-decimals-value  = decimals (default 0)
//   data-ui--manifesto--counter-up-v3-prefix-value    = string (default "")
//   data-ui--manifesto--counter-up-v3-suffix-value    = string (default "")
// ═══════════════════════════════════════════════════════════════════════════════

import { Controller } from "@hotwired/stimulus"
import { CountUp } from "countup.js"

export default class extends Controller {
  static values = {
    target:   { type: Number, default: 0 },
    duration: { type: Number, default: 2 },
    decimals: { type: Number, default: 0 },
    prefix:   { type: String, default: "" },
    suffix:   { type: String, default: "" },
    threshold:{ type: Number, default: 0.4 },
    once:     { type: Boolean, default: true },
  }

  connect() {
    this.counter = new CountUp(this.element, this.targetValue, {
      duration: this.durationValue,
      decimalPlaces: this.decimalsValue,
      prefix: this.prefixValue,
      suffix: this.suffixValue,
      separator: " ",
      useEasing: true,
    })

    if (this.counter.error) {
      console.warn("[counter-up-v3]", this.counter.error)
      return
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.counter.reset()
          this.counter.start()
          if (this.onceValue) this.observer.unobserve(this.element)
        }
      },
      { threshold: this.thresholdValue }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
    this.counter = null
  }
}
